import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Text from "../../containers/Text";
import GeneralDocumentsCard from "./GeneralDocumentsCard";
import { getGeneralDocsByUserId } from "../../api/requests/general-doc";
import "./generalDocuments.scss";
import "../document-cards/DocumentCards.scss";

const GeneralDocuments = ({ userId }) => {
  const { t } = useTranslation();
  const [documents, setDocuments] = useState([]);

  const totalDocuments = documents.length;

  useEffect(() => {
    const fetchGeneralDocs = async () => {
      if (!userId) {
        setDocuments([]);
        return;
      }

      try {
        const result = await getGeneralDocsByUserId(userId);
        setDocuments(result || []);
      } catch (error) {
        setDocuments([]);
      }
    };

    fetchGeneralDocs();
  }, [userId]);


  return (
    <div className="general-documents-page">
      <div className="title-wrapper">
        <h2 className="general-documents-title">
          <Text text={t("general-docs")} />
        </h2>
        <span className="count">{totalDocuments}</span>
      </div>
      <p className="general-docs-subtitle">
        <Text text={t("general-docs-subtitle")} />
      </p>
      <p className="general-docs-subtitle"></p>
      <GeneralDocumentsCard documents={documents} />
    </div>
  );
};

export default GeneralDocuments;
